import Api from 'fou-api'
import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import { FILE_NAME } from '../../../utils/constants/common'

export default {
  namespaced: true,

  state() {
    return {
      foundries: [],
      errorCountries: ['SY', 'CU', 'IR', 'KP', 'BY', 'RU'],
      warnCountries: ['UA'],
      staticTemplate: {},
      signedTemplate: '',
      staticNonFoundryTemplate: '',
      foundriesLoading: false,
      signedTemplateLoading: false,
      staticTemplateLoading: false,
      staticNonFoundryTemplateLoading: false,
      isSuccess: false,
      updatingContract: false,
      contractStatus: null,
      downloadFlag: false
    }
  },

  getters: {
    updatingContract: state => {
      return state.updatingContract
    },
    list: state => {
      return state.foundries
    },
    foundriesSpinner: state => {
      return state.foundriesLoading
    },
    printTemplate: state => {
      return state.signedTemplate
    },
    printTemplateSpinner: state => {
      return state.signedTemplateLoading
    },
    toBeSignedTemplate: state => {
      return state.staticTemplate
    },
    toBeSignedSpinner: state => {
      return state.staticTemplateLoading
    },
    staticTemplate: state => {
      return state.staticNonFoundryTemplate
    },
    isSuccessFull: state => {
      return state.isSuccess
    },
    staticTemplateSpinner: state => {
      return state.staticNonFoundryTemplateLoading
    },
    errorCountries: state => {
      return state.errorCountries
    },
    warnCountries: state => {
      return state.warnCountries
    },
    getContractStatus: state => {
      return state.contractStatus
    },
    getDownloadFlag: state => {
      return state.downloadFlag
    }
  },

  mutations: {
    updateContractStart(state) {
      state.updatingContract = true
    },
    updateContractComplete(state) {
      state.updatingContract = false
    },
    add(state, foundries) {
      state.foundries = foundries
    },
    clear(state) {
      state.foundries = []
    },
    setFoundriesLoader(state) {
      state.foundriesLoading = true
    },
    unsetFoundriesLoader(state) {
      state.foundriesLoading = false
    },
    setPrintTemplate(state, template) {
      state.signedTemplate = template
    },
    setPrintTemplateLoader(state) {
      state.signedTemplateLoading = true
    },
    unsetPrintTemplateLoader(state) {
      state.signedTemplateLoading = false
    },
    setStaticTemplate(state, template) {
      state.staticNonFoundryTemplate = template
    },
    setStaticTemplateLoader(state) {
      state.staticNonFoundryTemplateLoading = true
    },
    unsetStaticTemplateLoader(state) {
      state.staticNonFoundryTemplateLoading = false
    },
    clearPrintTemplate(state) {
      state.signedTemplate = ''
    },
    setToBeSignedTemplate(state, details) {
      // details will have foundry details and template
      state.staticTemplate = details
    },
    setToBeSignedTemplateLoader(state) {
      state.staticTemplateLoading = true
    },
    unsetToBeSignedTemplateLoader(state) {
      state.staticTemplateLoading = false
    },
    clearToBeSignedTemplate(state) {
      state.staticTemplate = {}
    },
    setIsSuccess(state) {
      state.isSuccess = true
    },
    unsetIsSuccess(state) {
      state.isSuccess = false
    },
    setContractStatus(state, status) {
      state.contractStatus = status
    },
    setdownloadPopupFlag(state) {
      state.downloadFlag = true
    },
    unsetdownloadPopupFlag(state) {
      state.downloadFlag = false
    }
  },

  actions: {
    getDownloadContract({ commit }, pid) {
      return new Promise((resolve, reject) => {
        Api.Contract.getSignedContract(pid)
          .then(respone => {
            if (respone.data.url === '') {
              commit('setdownloadPopupFlag')
            } else {
              commit('unsetdownloadPopupFlag')
              const data = respone.data.url
              const data2 = decodeURIComponent(data)
              const filename = FILE_NAME
              const aTag = document.createElement('a')
              aTag.href = data2
              aTag.setAttribute('download', filename)
              document.body.appendChild(aTag)
              aTag.click()
              aTag.remove()
            }
            return resolve(respone.data)
          })
          .catch(error => {
            let err = Errors.create(error)
            return reject(err)
          })
      })
    },

    putFoundryIdStatus({ commit, state }, options = {}) {
      commit('updateContractStart')
      return new Promise((resolve, reject) => {
        Api.Contract.updateContractStatus(options.ContractID, options)
          .then(respone => {
            commit('updateContractComplete')
            commit('setIsSuccess')
            return resolve(respone.data)
          })
          .catch(error => {
            let err = Errors.create(error)
            commit('updateContractComplete')
            return reject(err)
          })
      })
    },

    getAssignedFoundries({ commit }, module = 'agreements') {
      return new Promise((resolve, reject) => {
        commit('clear')
        Api.Users.getAllUserFoundries(module)
          .then(response => {
            const FoundreisData = response.data.foundries
            const Data = JSON.stringify(FoundreisData)
            localStorage.setItem('foundary', Data)
            commit('unsetFoundriesLoader')
            commit('add', response?.data?.foundries)
            resolve(response?.data?.foundries)
          })
          .catch(error => {
            let err = Errors.create(error)
            commit('unsetFoundriesLoader')
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    getPrintContractTemplate({ commit }, pid) {
      commit('setPrintTemplateLoader')
      return new Promise((resolve, reject) => {
        Api.Contract.getSignedTemplates(pid)
          .then(response => {
            commit('unsetPrintTemplateLoader')
            commit('setPrintTemplate', response.data)
            resolve(response.data)
          })
          .catch(error => {
            let err = Errors.create(error)
            commit('unsetPrintTemplateLoader')
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    getStaticContractTemplate({ commit }) {
      commit('setStaticTemplateLoader')
      return new Promise((resolve, reject) => {
        Api.Contract.getStaticAgreementTemplate()
          .then(response => {
            commit('unsetStaticTemplateLoader')
            commit('setStaticTemplate', response.data)
            resolve(response.data)
          })
          .catch(error => {
            let err = Errors.create(error)
            commit('unsetStaticTemplateLoader')
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    getToBeSignedContractTemplate({ commit }, pid) {
      commit('setToBeSignedTemplateLoader')
      return new Promise((resolve, reject) => {
        Api.Contract.getStaticTemplate(pid)
          .then(response => {
            commit('unsetToBeSignedTemplateLoader')
            commit('setToBeSignedTemplate', response.data)
            resolve(response.data)
          })
          .catch(error => {
            let err = Errors.create(error)
            commit('unsetToBeSignedTemplateLoader')
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    createNewContract({ commit }, options = {}) {
      commit('setToBeSignedTemplateLoader')
      return new Promise((resolve, reject) => {
        Api.Contract.createContract({ ...options })
          .then(response => {
            commit('unsetToBeSignedTemplateLoader')
            commit('setIsSuccess')
            resolve(response.data)
            const getID = response.data.contract.id
            localStorage.setItem('ContractID', getID)
          })
          .catch(error => {
            let err = Errors.create(error)
            commit('unsetToBeSignedTemplateLoader')
            commit('errors/add', err)
            reject(err)
          })
      })
    }
  },

  modules: {
    errors: VuexErrors
  }
}
